import { ADD_TEAMS } from "../constants/teamConstants";

export const addTeams = teams => ({
  type: ADD_TEAMS,
  payload: teams
});
